var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticStyle: { height: "60px" } }, [
        _c(
          "p",
          {
            staticStyle: {
              height: "50px",
              padding: "15px",
              "font-size": "30px"
            }
          },
          [_c("b", [_vm._v("Vessel : ")]), _vm._v(_vm._s(_vm.vessel_name))]
        ),
        _vm._v(" "),
        _c("hr")
      ]),
      _vm._v(" "),
      _c(
        "div",
        _vm._l(_vm.joborders, function(data, index) {
          return _c("div", { staticStyle: { height: "95px" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  height: "50px",
                  padding: "15px",
                  "font-size": "16px"
                },
                attrs: { id: "jobInfoText_" + index }
              },
              [_vm._v(_vm._s(data))]
            ),
            _vm._v(" "),
            _c("div", { key: index + "_" + _vm.typeSelectKey }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.typeSelect[index],
                    expression: "typeSelect[index]"
                  }
                ],
                staticStyle: { width: "50px" },
                attrs: { id: "type-0-" + index, type: "radio" },
                domProps: {
                  value: "Arrival",
                  checked: _vm._q(_vm.typeSelect[index], "Arrival")
                },
                on: {
                  change: function($event) {
                    return _vm.$set(_vm.typeSelect, index, "Arrival")
                  }
                }
              }),
              _vm._v("Arrival"),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.typeSelect[index],
                    expression: "typeSelect[index]"
                  }
                ],
                staticStyle: { width: "50px" },
                attrs: { id: "type-1-" + index, type: "radio" },
                domProps: {
                  value: "Service",
                  checked: _vm._q(_vm.typeSelect[index], "Service")
                },
                on: {
                  change: function($event) {
                    return _vm.$set(_vm.typeSelect, index, "Service")
                  }
                }
              }),
              _vm._v("Service"),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.typeSelect[index],
                    expression: "typeSelect[index]"
                  }
                ],
                staticStyle: { width: "50px" },
                attrs: { id: "type-2-" + index, type: "radio" },
                domProps: {
                  value: "Departure",
                  checked: _vm._q(_vm.typeSelect[index], "Departure")
                },
                on: {
                  change: function($event) {
                    return _vm.$set(_vm.typeSelect, index, "Departure")
                  }
                }
              }),
              _vm._v("Departure")
            ]),
            _vm._v(" "),
            _c("hr")
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticStyle: { height: "35px", padding: "5px 5px 0px" } }, [
        _c(
          "button",
          {
            attrs: { disabled: _vm.button_name == "Add" },
            on: {
              click: function($event) {
                return _vm.changeButtonName("Add")
              }
            }
          },
          [_vm._v("Add")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            attrs: { disabled: _vm.button_name == "Delete" },
            on: {
              click: function($event) {
                return _vm.changeButtonName("Delete")
              }
            }
          },
          [_vm._v("Delete")]
        )
      ]),
      _vm._v(" "),
      _c("layout-1", {
        style:
          "width:100%; height:calc(100vh - 100px - " +
          (95 * _vm.joborders.length + 90) +
          "px);",
        attrs: {
          table_name: "Port Stays",
          id: _vm.pageid,
          searchbar: false,
          termchange: false,
          term: _vm.term,
          button_name: _vm.button_name,
          button_perm: "82"
        },
        on: { search: _vm.setData, select: _vm.selectPortStay }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "nav-bar" }, [
        _c(
          "button",
          {
            on: {
              click: function($event) {
                return _vm.addNew()
              }
            }
          },
          [_vm._v("Add To New")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a325f090", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a325f090","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/add/Add_Port_Stays.vue
// module id = 655
// module chunks = 0